<template>
  <div :class="['small-drawer',{'active': value}]">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    width: {
      type: String,
      default: '300'
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(val) {
      if (val) {
        // 加定时器防止 点击按钮就触发弹出
        setTimeout(() => {
          window.addEventListener('click', this.isDrawer)
        });
      } else {
        window.removeEventListener('click', this.isDrawer)
      }
    }
  },

  methods: {
    isDrawer(e) {
      const ev = window.event || event;
      let find = false
      findParent(ev.target)
      function findParent(dom) {
        if (dom) {
          // 名字small-drawer为小抽屉 small-drawer-btn 为触发按钮 （没有遮罩层避免同类按钮切换会收回去）
          if (dom.className && (dom.className.includes('small-drawer') || dom.className.includes('small-drawer-btn'))) {
            find = true
            return
          }
          else {
            findParent(dom.parentNode)
          }
        }
        return
      }
      if (!find) this.$emit('input', false)
    }
  }
}
</script>
<style lang="scss" scope>
.small-drawer {
  width: 300px;
  height: calc(70%);
  background-color: #fff;
  position: fixed;
  top: 30%;
  right: -400px;
  z-index: 99;
  // border: 1px solid #f2f2f2;
  transition: right 0.8s ease-in-out;
  box-shadow: 0 0px 4px rgba(0, 0, 0, 0.2);
  &.active {
    right: 35px;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
/*滚动条宽 长,滚动条整体部分，其中的属性有width,height,background,border等。*/

.small-drawer::-webkit-scrollbar {
  width: 7px;
}

/*滚动条的滑轨背景颜色,可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果。*/

.small-drawer::-webkit-scrollbar-track {
  background-color: transparent;

  // -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.1);

  border-radius: 5px;
}

/* 滑块颜色 */

.small-drawer::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);

  border-radius: 5px;
}

/*滚动条两端的按钮。可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果。*/

.small-drawer::-webkit-scrollbar-button {
  background-color: #eee;

  display: none;
}

/* 横向滚动条和纵向滚动条相交处尖角的颜色 */

.small-drawer::-webkit-scrollbar-corner {
  background-color: black;
}
</style>
